<script setup lang="ts"></script>

<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5 10C3.5 6.68629 6.18629 4 9.5 4C12.8137 4 15.5 6.68629 15.5 10C15.5 13.3137 12.8137 16 9.5 16C6.18629 16 3.5 13.3137 3.5 10ZM9.5 2C5.08172 2 1.5 5.58172 1.5 10C1.5 14.4183 5.08172 18 9.5 18C11.3487 18 13.051 17.3729 14.4056 16.3199L19.7929 21.7071C20.1834 22.0976 20.8166 22.0976 21.2071 21.7071C21.5976 21.3166 21.5976 20.6834 21.2071 20.2929L15.8199 14.9056C16.8729 13.551 17.5 11.8487 17.5 10C17.5 5.58172 13.9183 2 9.5 2Z"
      fill="currentColor"
    />
  </svg>
</template>
